/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs'; 
import { switchMap, map } from 'rxjs/operators'; 
import { PrinterSettingsDS, PrinterSettingsDSData } from '../../../interfaces/masters/printersettingsds';
import { PrinterSettingDsApi } from '../api/printersettingds.api';

@Injectable()
export class PrinterSettingsDsService extends PrinterSettingsDSData {

  constructor(private api: PrinterSettingDsApi) {
    super();
  }

  list(url: string): Observable<PrinterSettingsDS[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PrinterSettingsDS>{
      return this.api.getById(url);
  }

  create(url: string, data:any): Observable<PrinterSettingsDS> {
    return this.api.add(url,data);
  }

  update(url: string, data:any): Observable<PrinterSettingsDS> {
    return this.api.update(url,data);
  }
 
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
